var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-button',{attrs:{"type":"button","variant":_vm.variant,"id":"traBtn"+_vm.suffix+_vm.id,"to":_vm.to}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }